import Hero from "@/features/hero";
import { Alert as IAlert } from "@/features/types";
import { theme } from "@/theme";
import {
  Alert,
  Box,
  Container,
  Divider,
  Slide,
  SlideProps,
  Snackbar,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useState } from "react";
import { Element } from "react-scroll";
import Footer from "./features/footer";
import How from "./features/how";
import Put from "./features/learn";
import Menu from "./features/menu/components";
import Timeline from "./features/timeline";

type TransitionProps = Omit<SlideProps, "direction">;

function App() {
  const [alert, setAlert] = useState<IAlert | undefined>();

  function TransitionDown(props: TransitionProps) {
    return <Slide {...props} direction="down" />;
  }

  const renderAlert = () => {
    return (
      <>
        {alert && (
          <Snackbar
            open={Boolean(alert)}
            TransitionComponent={TransitionDown}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              severity={alert.severity}
              onClose={() => setAlert(undefined)}
            >
              {alert.title}
            </Alert>
          </Snackbar>
        )}
      </>
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{ background: theme.palette.surface.main }}
        display={"flex"}
        gap={8}
        flexDirection={"column"}
      >
        {renderAlert()}
        <Element name={"menu"}>
          <Menu />
        </Element>
        <Box p={4}>
          <Container maxWidth={"md"}>
            <Hero setAlert={setAlert} />
          </Container>
        </Box>
        <Element name={"convert"}>
          <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
            <Timeline />
          </Box>
        </Element>
        <Box bgcolor={"#F8F2F7"} p={8}>
          <Container>
            <How />
          </Container>
        </Box>
        <Box p={8}>
          <Container>
            <Put />
          </Container>
        </Box>
        <Box p={8}>
          <Container>
            <Divider />
            <Footer />
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default App;
